import { useMemo } from 'react';
import { Slider } from '../ui/slider';

const sliderStyles = '[&>span:first-child]:bg-white/20 [&>span:first-child>span]:bg-gold-400 [&>span:last-child]:border-gold-400 [&>span:last-child]:bg-white';
const yearLabels = { 1: 'Year 1 - BUILD', 2: 'Year 2 - OPTIMIZE', 3: 'Year 3+ - PROTECT' };

function ControlRow({ label, display, value, min, max, onChange, testId }) {
    const sliderValue = useMemo(() => [value], [value]);
    return (
        <div>
            <div className="flex items-center justify-between mb-3">
                <p className="text-gray-300 text-sm font-semibold">{label}</p>
                <p className="text-gold-400 font-montserrat font-bold text-sm" data-testid={`${testId}-value`}>{display}</p>
            </div>
            <Slider
                value={sliderValue}
                min={min}
                max={max}
                step={1}
                onValueChange={(v) => onChange(v[0])}
                className={sliderStyles}
                data-testid={testId}
            />
        </div>
    );
}

export function CalculatorControls({ vas, setVas, year, setYear, wage, setWage }) {
    return (
        <div className="space-y-8 mb-10">
            <ControlRow label="Number of VAs" display={vas === 1 ? '1 VA' : `${vas} VAs`} value={vas} min={1} max={5} onChange={setVas} testId="calc-vas-slider" />
            <ControlRow label="Relationship year" display={yearLabels[year]} value={year} min={1} max={3} onChange={setYear} testId="calc-year-slider" />
            <ControlRow label="Assumed VA wage" display={`$${wage}/hour`} value={wage} min={8} max={12} onChange={setWage} testId="calc-wage-slider" />
        </div>
    );
}
